import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Sparkles } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/data/content";

export default function CtaBanner({ onPlanTrip }) {
  return (
    <section id="cta" className="px-4 md:px-10 my-24" data-testid="cta-banner">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="relative max-w-7xl mx-auto rounded-[2.5rem] md:rounded-[3rem] overflow-hidden p-10 md:p-20 text-center"
        style={{
          background:
            "radial-gradient(circle at 20% 20%, rgba(201,162,39,0.25), transparent 60%), radial-gradient(circle at 80% 80%, rgba(21,76,121,0.5), transparent 60%), linear-gradient(135deg, #0A2342 0%, #154C79 100%)",
        }}
      >
        {/* gold rings */}
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full border border-[#C9A227]/20" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full border border-[#C9A227]/10" />

        <div className="relative">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs tracking-[0.2em] uppercase">
            <Sparkles className="w-3.5 h-3.5 text-[#C9A227]" /> Crafted for you
          </div>

          <h2 className="font-display text-white text-4xl md:text-6xl lg:text-7xl mt-6 leading-[1.05]">
            Let's design your <br className="hidden md:block" />
            <span className="text-[#C9A227]">dream journey.</span>
          </h2>

          <p className="mt-6 text-white/75 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            Tell us where your heart is wandering. A senior consultant will respond within 24 hours with a personalised proposal — at no cost, no obligation.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a
  data-testid="cta-plan-btn"
  href={`https://wa.me/${9622469097}?text=${encodeURIComponent(
    "Hi Travwave, I'd like to get a free consultation."
  )}`}
  target="_blank"
  rel="noopener noreferrer"
  className="btn-gold"
>
  Get Free Consultation
</a>
            <a
              data-testid="cta-whatsapp-btn"
              href={`https://wa.me/${9622469097}?text=${encodeURIComponent(
                "Hi Travwave, I'd like to plan a luxury trip."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
            >
              <img src="/Whatsapp.png"
              alt="WhatsApp" className="w-10 h-10 object-contain"/>
              WhatsApp Expert
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
